import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { TextboxMaskedControl } from "@/Common/Components/Inputs/TextboxMaskedControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";
import { ResourceProvider } from "@/Common/Resources/StaticResources";

import styles from "./EmailInputSection.module.scss";

interface IEmailInputSectionProps {
    error: string | null;
    emailAddress: string;
    isEmailValid: boolean;
    isNotifiedByEmail: boolean;
    isOkToContact: boolean;
    allowEmptyEmail: boolean;
    stringProvider?: ResourceProvider;

    onEmailChange: (emailAddress: string, isEmailValid: boolean) => void;
    setIsNotifiedByEmail: (isNotifiedByEmail: boolean) => void;
    setIsOkToContact: (isOkayToContact: boolean) => void;
    onEnterPressed: () => void;
}

function EmailInputSection(props: IEmailInputSectionProps): JSX.Element {
    const { getText } = useTranslation(props.stringProvider);

    function isValidEmail(email: string): boolean {
        if (IsNullOrWhiteSpace(email) && props.allowEmptyEmail) {
            return true;
        }

        return ValidationHelper.isExactMatch(email, ValidationHelper.emailRegex);
    }

    return (
        <div className={styles.emailColumns}>
            <label className={styles.emailLabel} htmlFor="Email_id">
                {getText("EmailLabel")}
            </label>
            <div>
                <div>
                    <TextboxMaskedControl
                        isValid={props.isEmailValid}
                        alphanumericIncludesPeriod={false}
                        id="Email_id"
                        value={props.emailAddress}
                        onChangeFunction={value => props.onEmailChange(value, isValidEmail(value))}
                        returnMaskedValue={true}
                        mask={ValidationHelper.GetEmailEditMaskPattern()}
                        validationErrorMessage={getText("InvalidLabel")}
                        isEmail={true}
                        dataCy="login-email"
                        allowEmpty={props.allowEmptyEmail}
                        onKeyDown={e => {
                            if (e.key === "Enter")
                                props.onEnterPressed();
                        }}
                    />
                </div>
                {props.error && (
                    <div>
                        <label className="label-error"> {props.error} </label>
                    </div>
                )}
                <div className="padding-md-top">
                    <CheckboxControl
                        checked={props.isOkToContact}
                        label={getText("OkToContactLabel")}
                        onChange={checked => props.setIsOkToContact(checked)}
                        dataCy="login-okToContact"
                    />
                </div>
                <div>
                    <CheckboxControl
                        checked={props.isNotifiedByEmail}
                        label={getText("SendUpdateNotificationByEmailLabel")}
                        onChange={checked => props.setIsNotifiedByEmail(checked)}
                        dataCy="login-isNotifiedByEmail"
                    />
                </div>
            </div>
        </div>
    );
}

export { EmailInputSection };
